export function percentage(value = 0, decimals = 2) {
  return `${(value * (10 ** (2 + decimals))).toFixed(0) / (10 ** decimals)} %`;
}

export function money(value = 0, currencySymbol = '€') {
  if (!value) {
    return 'N/A';
  }
  return `${currencySymbol} ${value.toLocaleString()}`;
}

export function toFeet(meters = 0) {
  return Math.round(meters * 3.28084);
}

export function toMeters(feet = 0) {
  return Math.round(feet / 3.28084);
}

export function capitalize(input) {
  if (!input) {
    return '';
  }
  return input.charAt(0).toUpperCase() + input.slice(1);
}

export function publicPath() {
  return process.env.BASE_URL;
}
